module.exports = __webpack_public_path__ + "d77bd9f82ede02a72d9775c93b22cdea.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owl-item-types/body.png
// module id = 1722
// module chunks = 0